<template>
  <div class="base-dual-bar-chart">
    <BaseText1 :text="val1.toString()"/>
    <div class="chart">
      <div class="val val-1" ref="val-1"/>
      <BaseText2 :text="label"/>
      <div class="val val-2" ref="val-2"/>
    </div>
    <BaseText1 :text="val2.toString()"/>
  </div>
</template>

<script>
import BaseText1 from '@/components/BaseText1/BaseText1'
import BaseText2 from '@/components/BaseText2/BaseText2'
import anime from 'animejs'
export default {
  components: {
    BaseText1,
    BaseText2
  },
  props: {
    label: {
      type: String,
      required: true
    },
    val1: {
      type: [Number, String],
      required: true
    },
    val2: {
      type: [Number, String],
      required: true
    }
  },
  mounted () {
    this.animate()
  },
  methods: {
    animate () {
      anime({
        targets: this.$refs['val-1'],
        scaleX: [0, this.val1 / 100]
      })
      anime({
        targets: this.$refs['val-2'],
        scaleX: [0, this.val2 / 100]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.base-dual-bar-chart {
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
}
.chart {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-5);
  border: var(--border-1);
  margin: 0 var(--spacing-4);
  background: rgba(0, 0, 0, 0.4);
}
.val {
  flex: 1;
}
.val-1 {
  background: var(--color-red-1);
  transform-origin: right center;
}
.val-2 {
  background: var(--color-blue-1);
  transform-origin: left center;
}
.base-text-1 {
  width: 2.5em;
}
.base-text-2 {
  width: 8em;
  flex-shrink: 0;
  margin-bottom: -0.1em;
}
</style>
